import DragAndDropPreview from '../components/DragAndDropPreview.vue';
import Vue from 'vue';
const Preview = Vue.extend(DragAndDropPreview);
let preview;
export const getDragAndDropPreview = async (nodes) => {
    return new Promise((resolve) => {
        if (!preview) {
            preview = new Preview().$mount();
            document.body.appendChild(preview.$el);
        }
        preview.update(nodes);
        preview.$on('loaded', () => {
            resolve(preview.$el);
            preview.$off('loaded');
        });
    });
};
